module.exports = __webpack_public_path__ + "static/media/pie-chart-race.042ad791.svg";